import React from 'react';

import { useUIContext } from 'lib/context/UIContext/UIContext';

import { BreadcrumbList } from 'components/shared/Breadcrumb/Breadcrumb';
import { useBreadcrumbContext } from 'components/shared/Breadcrumb/context/BreadcrumbContext';
import Button from 'components/shared/Button/Button';
import Typography from 'components/shared/Typography/Typography';

const ModalHeader = ({
  setDetails,
  selectedData,
  tab,
  lockNext,
  disableClick,
  headerActions,
  trimSteps
}) => {
  const { current, steps } = useBreadcrumbContext();
  const { device } = useUIContext();
  const isDesktop = device === 'desktop' || device === 'laptop';
  const isMobile = device === 'tablet-sm' || device === 'mobile';

  const Actions = headerActions || null;

  const finalTitle =
    steps?.length > 1 ? current?.headerTitle : (current?.headerTitle ?? current?.title);

  return (
    <div className="flex w-full items-center justify-between gap-4">
      <div className="flex min-w-0 flex-1 gap-3 sm:flex-col xs:flex-col">
        {finalTitle &&
          (isMobile ? (
            <Typography variant="p" size="small" className="text-neutral-800">
              {finalTitle}
            </Typography>
          ) : (
            <p className="whitespace-nowrap text-sm font-medium text-neutral-800">{finalTitle}</p>
          ))}
        {steps?.length > 1 && (
          <BreadcrumbList
            textClassName="text-sm text-neutral-800"
            indicator="slash"
            data={selectedData}
            lockNext={lockNext}
            disableClick={disableClick}
            trimSteps={trimSteps}
          />
        )}
      </div>
      <div className="flex items-center gap-2">
        {headerActions && <Actions />}
        {tab?.details?.alwaysShow && !isDesktop && (
          <Button
            variant="link"
            icon="document-preview-mono"
            iconColor="neutral"
            iconSize={16}
            className="h-full"
            onClick={() => setDetails(true)}
          />
        )}
      </div>
    </div>
  );
};

export default ModalHeader;
